import { useState, useEffect } from 'react';
import { lazyLoadHtmlImages } from '../utils/lazyImages';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CommentReply } from '../components/CommentReply';
import { EditBox } from '../components/EditBox';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReply,
  removeUserLounge,
  wholikeCommentReply,
  likeCommentReply,
} from '../redux/lounges/slice';
import { selectLounges } from '../redux/lounges/selectors';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createModuleDeclaration } from 'typescript';
import { LikeCommentReply } from '../components/LikeCommentReply';

import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { COMPLETIONSTATEMENT_TYPES } from '@babel/types';
import { format } from 'path';
import { getUserMembershipBadges } from '../utils/userMembershipBadges';
import { getMouseWaitUserAvatarUrl } from '../utils/avatar';
import { useResolvedMentionHtml } from '../utils/mentionResolver';
import { formatCommentDate } from '../utils/commentThread';
import { CommentReportModal } from './CommentReportModal';

type CommentListPropsType = {
  chatId: any;
  cmt: any;
  replyShow: boolean;
  stickerData: any;
};
export const CommentList: React.FC<CommentListPropsType> = ({
  chatId,
  cmt,
  replyShow,
  stickerData,
}) => {
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const [showReply, SetShowReply] = useState<any | string>(replyShow);
  const commentUser = cmt.commentuser ?? cmt.user ?? {};
  const [replyTargetUserName, setReplyTargetUserName] = useState<any | string>(
    commentUser?.user_name
  );
  const [replyTargetReplyId, setReplyTargetReplyId] = useState<any | null>(null);
  const [replyTargetText, setReplyTargetText] = useState<any | string>(
    cmt.chat_reply_msg
  );
  const [editbox, SetEditBox] = useState<any | string>(false);

  const token = localStorage.getItem('token');
  const loginuserid = localStorage.getItem('user_id');
  //console.log(token);
  const showReplyIcon = (
    targetUserName?: string,
    targetReplyId?: any,
    targetText?: string
  ) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      setReplyTargetUserName(targetUserName || commentUser?.user_name);
      setReplyTargetReplyId(targetReplyId ?? null);
      setReplyTargetText(targetText || cmt.chat_reply_msg);
      SetShowReply(true);
    }
  };
  const closeReplyBox = () => {
    SetShowReply(false);
    setReplyTargetUserName(commentUser?.user_name);
    setReplyTargetReplyId(null);
    setReplyTargetText(cmt.chat_reply_msg);
  };
  const showEditBox = () => {
    SetEditBox(!editbox);
  };

  const [modalIsOpen, setIsOpen] = useState(false);

  const { items } = useSelector(selectLounges);

  const openReport = () => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      setIsOpen(true);
    }
  };

  const [RemoveType, setRemoveType] = useState<any | string>('C');
  const onRemove = (ban_chat_id: any) => {
    dispatch<any>(removeUserLounge({ ban_chat_id, RemoveType })).then(
      (res: any) => {
        window.location.reload();
      }
    );
  };

  const [likeuserlist, setLikeUserList] = useState<any | string>(false);
  const [likeuserdata, setLikeUserData] = useState<any | string>([]);

  const formatedMsg = useResolvedMentionHtml(cmt.chat_reply_msg);
  const membershipBadges = getUserMembershipBadges(commentUser, items);

  // const formattedMessage = async (message: string) => {
  //   var domParser = new DOMParser();
  //   var doc = domParser.parseFromString(message, 'text/html');
  //   var msg = doc.body.innerText;
  //   let replacemsg = msg.match(/@(\w+)/g)?.map(match => match.substring(1));
    
  //   {
  //       await replacemsg?.map((val) => {
  //       val.length > 0 && axios
  //         .get(GET_BASE_URL + '/api/v1/getUser?name=' + val)
  //         .then((response: any) => {
  //           if(response.data.data.length > 0) {
  //             let id = response.data.data[0].id;
  //             let htmltext = "<a href='/../../user/" + id + "/mypost'>" + val + "</a>";
  //             msg = msg.replace('@' + val, htmltext);
  //             console.log('aaaaaaaa', msg)
  //           }
  //       });

  //     })
  //   }
    
    // setFormatedMsg(msg)
    // return msg;
    // var links = doc.querySelectorAll('.mention');
    // links.forEach(function (linkTag: any) {
    //   var aTag = document.createElement('a');
    //   aTag.href = `../../user/${linkTag.dataset.id}/mypost`;

    //   aTag.style.color = '#0000EE';
    //   aTag.style.marginRight = '3px';
    //   aTag.innerHTML = linkTag.innerHTML;
    //   linkTag.parentNode.replaceChild(aTag, linkTag);
    // });
    // console.log('aaaaaa', msgtext)
    // return "<p>asdf</p>";

  return (
    <>
      <>
        <div
          className={`mw-comment-thread ${
            showReply || cmt.commentsreply?.length ? 'mw-comment-thread--connected' : ''
          }`}
        >
          <div className='comm-bo mw-comment-card d-flex flex-row' key={cmt.chat_id}>
            <div className='small-c mw-comment-avatar'>
              <Link to={`/disneyland/user/${commentUser?.user_id}/mypost`}>
                <img
                  src={getMouseWaitUserAvatarUrl(
                    commentUser,
                    GET_BASE_URL_IMAGE +
                      '/disneyland/images/thumbs/' +
                      commentUser.image
                  )}
                  className='com-imggg'
                  alt={`${commentUser?.user_name || 'MouseWaiter'} avatar`}
                />
              </Link>
            </div>
            <div className='comm-c mw-comment-main d-flex'>
              <div className='mw-comment-header'>
                <div className='mw-comment-author-row'>
                  <Link
                    className='mw-comment-author-name'
                    to={`/disneyland/user/${commentUser?.user_id}/mypost`}
                  >
                    {commentUser?.user_name}
                  </Link>
                  {membershipBadges.map((badge) => (
                    <span
                      key={badge.key}
                      className={`mw-comment-badge ${badge.className}`}
                      title={badge.title}
                    >
                      {badge.label}
                    </span>
                  ))}
                </div>
                <div className='com-tt mw-comment-stats'>
                  <span className='mw-comment-date'>
                    {formatCommentDate(cmt?.chat_reply_date)}
                  </span>
                  <span>{commentUser?.rank}</span>
                  <span>#{commentUser?.position}</span>
                </div>
              </div>

              <div className='commentlist mw-comment-message'>
                <div
                  dangerouslySetInnerHTML={{
                    __html: lazyLoadHtmlImages(formatedMsg)
                      .replace('<p>', '<span>')
                      .replace('</p>', '</span>')
                      .replace('<br>', ''),
                  }}
                />
              </div>

              <div className='co-l mw-comment-actions'>
                <LikeCommentReply
                  likecount={cmt.no_of_likes}
                  chat_id={cmt.chat_id}
                  comment_id={cmt.chat_reply_id}
                  reply_id={''}
                  commnet_userid={commentUser.user_id}
                  type={'C'}
                  page={'DL'}
                />
                <button
                  type='button'
                  onClick={() => showReplyIcon(commentUser?.user_name)}
                >
                  Reply
                </button>
                {commentUser.user_id == loginuserid && (
                  <>
                    <button type='button' onClick={showEditBox}>Edit</button>
                    <button
                      type='button'
                      onClick={() => {
                        if (window.confirm('Delete this comment?'))
                          onRemove(cmt.chat_reply_id);
                      }}
                    >
                      Delete
                    </button>
                  </>
                )}
                <button
                  type='button'
                  className='mw-comment-action--quiet'
                  onClick={openReport}
                >
                  Flag
                </button>
              </div>
            </div>
          </div>

          <CommentReportModal
            isOpen={modalIsOpen}
            onClose={() => setIsOpen(false)}
            itemId={cmt.chat_reply_id}
            type='R'
            park='DL'
          />

          <EditBox
            replyData={''}
            id={''}
            chatId={cmt.chat_id}
            chat_reply_id={cmt.chat_reply_id}
            chat_reply_msg={cmt.chat_reply_msg}
            stickerData={stickerData}
            editbox={editbox}
            type={'C'}
          />

          <CommentReply
            replyData={cmt.commentsreply || []}
            replyShow={showReply}
            chatId={cmt.chat_id}
            chat_reply_id={cmt.chat_reply_id}
            stickerData={stickerData}
            parentCommentUserName={commentUser?.user_name}
            parentCommentText={cmt.chat_reply_msg}
            replyTargetUserName={replyTargetUserName}
            replyTargetReplyId={replyTargetReplyId}
            replyTargetText={replyTargetText}
            onRequestReply={showReplyIcon}
            onCancelReply={closeReplyBox}
            onReplySubmitted={closeReplyBox}
          />
        </div>
      </>
    </>
  );
};
